export default __webpack_public_path__ + "static/media/151-hacksaw.50f7d22c.png";